<template>
  <v-snackbar
    :timeout="3500"
    v-model="isActive"
    :color="color"
    class="subheading"
    auto-height
    v-bind="options">
    {{ message }}
    <v-btn color="white" flat @click.stop="isActive = false">{{ $t('azioni.chiudi') }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
    name: 'Snackbar',
    data: () => ({
        isActive: false,
        message: '',
        color: '',
        options: {}
    }),
    methods: {
        show (message, color = '', options = { bottom: true, left: true }) {
            this.message = message
            this.color = color
            this.options = options
            this.isActive = true
        },
        showServerError (e, options = { bottom: true, left: true }) {
            //  Mostro l'errore solo nel caso non sia un errore di accesso
            if (!e.response || (e.response.status !== 401 && e.response.status !== 408)) {
                this.show(this.$t('errori.server'), 'error', options)
            }
        }
    }
}
</script>
